module.exports = __webpack_public_path__ + "static/amm_logo-92720f09e5881bdb6f74c6f8965b0a42.svg";